import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { decorateWith } from 'helpers/decorator';
import { withSagas } from 'decorators/Sagas';
import { hideModal, showModal } from 'redux/modules/modals';
import { LocaleSwitcher } from './LocaleSwitcher';
import { updateAccountLocale, watchAccountLocaleSagas } from './LocaleSwitcher.saga';

export const mapDispatchToProps = {
  hideModal,
  showModal,
  updateAccountLocale,
};

export const LocaleSwitcherContainer = decorateWith(
  withSagas({
    watch: watchAccountLocaleSagas,
  }),
  connect(null, mapDispatchToProps),
  injectIntl
)(LocaleSwitcher);
